import React, { useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { icons } from '../images';
import { action } from '../lib/actionHelpers.js';
import SVG from 'images/svg/SVG.js';

const ImagePopup = () => {
  const { index, images } = useSelector((state) => state.ui.imagePopup);

  const [rotation, setRotation] = useState(0);

  const activeImage = images[index];

  const handleClose = () => {
    action('uiPatchImagePopup', { index: null, images: [] });
  };

  const handleRotateClick = () => {
    const newRotation = rotation + 90 > 270 ? 0 : rotation + 90;
    setRotation(newRotation);
  };

  const handleThumbnailClick = (e, n, idx) => {
    action('uiPatchImagePopup', { index: idx });
  };

  const handleKeydown = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      handleClose();
    }
    if (e.key === 'ArrowLeft' && activeImage) {
      const newIndex = index - 1 < 0 ? images.length - 1 : index - 1;
      action('uiPatchImagePopup', { index: newIndex });
    }
    if (e.key === 'ArrowRight' && activeImage) {
      const newIndex = index + 1 > images.length - 1 ? 0 : index + 1;
      action('uiPatchImagePopup', { index: newIndex });
    }
  };

  useLayoutEffect(() => {
    if (index !== undefined && index !== null) {
      window.addEventListener('keydown', handleKeydown);
    }
    return () => window.removeEventListener('keydown', handleKeydown);
  }, [activeImage, index]);

  return (
    <div className={`image-popup ${activeImage ? 'active' : ''}`}>
      <div className="image-popup-backing" onClick={handleClose}>
        &nbsp;
      </div>
      <div className={`image-popup-card rotate-${rotation}`}>
        <div className="close-button">
          <img alt="Close" width={20} height={20} src={icons['icon-close']} onClick={handleClose} />
        </div>
        <div className="image-popup-content">
          {activeImage && <img alt="Active" src={(activeImage || {}).src} />}
          <div className="image-popup-meta">
            <div>
              <div>{(activeImage || {}).title}</div>
              <div>{(activeImage || {}).size}</div>
            </div>
            {activeImage && (
              <div>
                <div>{`Image ${index + 1} of ${images.length}`}</div>
                <div>
                  <a href={(activeImage || {}).src} download={(activeImage || {}).title}>
                    <img alt="Download" width={20} height={20} src={icons['icon-download']} />
                  </a>
                  <SVG icon={'Rotate'} width={20} height={20} invert={true} onClick={handleRotateClick} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="image-popup-thumbnails">
        {activeImage &&
          images.map((n, idx) => (
            <div className={`thumbnail-wrapper ${idx === index ? 'active' : ''}`} key={idx} onClick={(e) => handleThumbnailClick(e, n, idx)}>
              <img alt="Thumbnail" className={`thumbnail`} src={n.src} />
            </div>
          ))}
      </div>
    </div>
  );
};

export default ImagePopup;
